
webpack.register(
    'components/svg-image/svg-image',
    function() {
        return require('components/svg-image/svg-image');
    },
    false
);
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
webpack.register(
    'components/clamp-text/clamp-text',
    function() {
        return require('components/clamp-text/clamp-text');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/svg-image/svg-image'/>\r\n<can-import from='components/image-universal/image-universal'/>\r\n<can-import from='components/clamp-text/clamp-text'/>\r\n\r\n{{#if alert}}\r\n    <div class=\"c-alert {{#isVisible}}is-visible{{/isVisible}} {{#if alert.isLive}}is-live{{/if}}\">\r\n        <div class=\"c-alert__image-holder\">\r\n            <image-universal {image}=\"alert.image\" class-name=\"c-alert__image\" />\r\n        </div>\r\n        <div class=\"c-alert__content\">\r\n            <div class=\"c-alert__text\">\r\n                {{alert.text}}\r\n            </div>\r\n            {{#if alert.button}}\r\n                <div class=\"js-cta-link c-alert__row s-link\">\r\n                    {{alert.button.title}}\r\n                    <div class=\"c-alert__button\">\r\n                        <svg-image class-name=\"c-alert__link-button\" image=\"sprites.svg#icon-arrow\"></svg-image>\r\n                    </div>\r\n                </div>\r\n            {{/if}}\r\n        </div>\r\n        <div class=\"js-close-button c-alert__close-button\">\r\n            <svg-image image=\"sprites.svg#icon-close\"></svg-image>\r\n        </div>\r\n    </div>\r\n{{/if}}\r\n");